import { fmtPct } from "@/lib/format";

/**
 * Retail sentiment derived from CFTC "Non-Reportable" positions
 * (small / retail traders, the regulated definition).
 */
export default function RetailSentiment({ nonreptLong, nonreptShort, testid }) {
  const total = (nonreptLong || 0) + (nonreptShort || 0);
  if (!total) {
    return <span className="text-zinc-600 text-[11px]">—</span>;
  }
  const longPct = (nonreptLong / total) * 100;
  const shortPct = 100 - longPct;
  const dominant = longPct >= 50 ? "LONG" : "SHORT";
  const dominantCls = longPct >= 50 ? "text-pos" : "text-neg";

  return (
    <span
      className="inline-flex items-center gap-1.5 min-w-[112px]"
      data-testid={testid}
      title={`Retail (Non-Reportable) Long ${longPct.toFixed(0)}% / Short ${shortPct.toFixed(0)}%`}
    >
      <span className="relative inline-block h-2.5 w-14 bg-zinc-900 border border-zinc-800">
        <span
          className="absolute inset-y-0 left-0"
          style={{ width: `${longPct}%`, backgroundColor: "rgba(var(--heat-pos-rgb),0.7)" }}
        />
        <span
          className="absolute inset-y-0 right-0 bg-red-500/70"
          style={{ width: `${shortPct}%` }}
        />
      </span>
      <span className="text-[11px] tabular-nums">
        <span className="text-pos">{fmtPct(longPct)}</span>
        <span className="text-zinc-700"> / </span>
        <span className="text-neg">{fmtPct(shortPct)}</span>
      </span>
      <span className={`text-[11px] tracking-widest ${dominantCls}`}>{dominant}</span>
    </span>
  );
}
